import { LocalStream, RemoteStream } from '@tencent/wemeet-websdk-next';
import { useEffect, useState } from 'react';

const formatAudioLevel = (level: number, isPhoneUser: boolean) => {
  // 电话用户的音量范围比普通用户小很多，需要更大的系数
  // 老逻辑，照搬旧版本代码，这两个70和50的来源没找到
  const ratio = isPhoneUser ? 70 : 50;
  const transformAudioLevel = Math.floor(level * ratio);
  return transformAudioLevel >= 10 ? 10 : transformAudioLevel;
};

export const useAudioLevel = (
  stream: LocalStream | RemoteStream | undefined,
  isPhoneUser?: boolean,
  available = true,
) => {
  const [audioLevel, setAudioLevel] = useState<number>(0);

  useEffect(() => {
    let time: NodeJS.Timer;
    if (stream && available) {
      time = setInterval(() => {
        try {
          const streamLevel = stream.getAudioLevel();
          const availableLevel = formatAudioLevel(streamLevel, !!isPhoneUser);
          setAudioLevel(availableLevel);
        } catch {
          setAudioLevel(0);
        }
      }, 100);
    }

    return () => {
      if (time) {
        clearInterval(time);
      }
    };
  }, [stream, available]);

  return audioLevel;
};
